<form class="w-100" (ngSubmit)="onSubmit()" [formGroup]="form" *ngIf="listAdditionalCost?.length">
    <!-- Utilidad general: un solo % por servicio. -->
    <section class="utilities-group" *ngIf="generalServices.length">
        <div class="utilities-group__head">
            <span class="utilities-group__title">Utilidad general</span>
            <small>Un mismo porcentaje sin importar quién pague el servicio.</small>
        </div>
        <div class="d-flex flex-wrap">
            <div class="d-flex flex-column col-lg-3 col-sm-6 mb-3" *ngFor="let service of generalServices">
                <mat-form-field *ngIf="form.get(service.name + '.utility') as control" appearance="outline">
                    <mat-label>{{ service.name }}<span class="asterisk">*</span></mat-label>
                    <input matInput type="number" onlyNumbersInt [formControl]="control">
                    <mat-error *ngIf="control.errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                    <mat-error *ngIf="control.errors?.max">
                        {{ utils.giveMessageError('MAX_VALUE_EXCEED', 'utilidad', "100" )}}
                    </mat-error>
                    <mat-error *ngIf="control.errors?.min">
                        {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'utilidad', minUtility) }}
                    </mat-error>
                    <i class="fas fa-percent" matSuffix></i>
                </mat-form-field>
            </div>
        </div>
    </section>

    <!-- Utilidad por actor: un % según quién pague (utilityByActor). -->
    <section class="utilities-group" *ngIf="byActorServices.length">
        <div class="utilities-group__head">
            <span class="utilities-group__title">Utilidad según quién paga</span>
            <small>Estos servicios tienen un porcentaje distinto para cada actor que puede pagarlos.</small>
        </div>
        <div class="by-actor-card" *ngFor="let service of byActorServices">
            <div class="by-actor-card__title">{{ service.name }}</div>
            <div class="d-flex flex-wrap">
                <div class="d-flex flex-column col-lg-3 col-sm-6"
                    *ngFor="let who of getWhosByService(service.name)?.controls; let actorIndex = index">
                    <mat-form-field *ngIf="who.get('utility') as control" appearance="outline">
                        <mat-label>{{ actorLabel(who.get('whoToPay').value) }}<span class="asterisk">*</span></mat-label>
                        <input matInput type="number" onlyNumbersInt [formControl]="control">
                        <mat-error *ngIf="control.errors?.required">
                            {{ utils.giveMessageError('MANDATORY_FIELD') }}
                        </mat-error>
                        <mat-error *ngIf="control.errors?.max">
                            {{ utils.giveMessageError('MAX_VALUE_EXCEED', 'utilidad', "100" )}}
                        </mat-error>
                        <mat-error *ngIf="control.errors?.min">
                            {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'utilidad', minUtility) }}
                        </mat-error>
                        <i class="fas fa-percent" matSuffix></i>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </section>

    <div class="button-container justify-content-end">
        <button mat-raised-button color="primary" class="bg-color-primary" type="submit"
            [disabled]="saving">
            Guardar
        </button>
    </div>
</form>
